import { createFileRoute } from '@tanstack/react-router'
import { UnauthorizedPage } from '@/pages/ErrorPages'

export const Route = createFileRoute('/_app/unauthorized')({
  head: () => ({ meta: [{ title: 'Access Denied · AERRIS' }] }),
  component: UnauthorizedPage,
})
